@if (!showCandidateForm()) {
<!-- Form Content -->
<form [formGroup]="jobForm" class="flex flex-col gap-4">

  <!-- Header -->
  <div class="bg-[#212529] p-4 b-4 w-full">
    <h1 class="text-lg md:text-3xl font-semibold text-white">Create Job</h1>
    <p class="text-indigo-100 mt-1">Create job position and description</p>
  </div>

  <!-- Left Column -->
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Job Title</mat-label>
    <input matInput formControlName="jobTitle" placeholder="e.g. Senior Frontend Developer">
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Job Description</mat-label>
    <textarea matInput formControlName="description" rows="4" placeholder="Enter detailed job description"></textarea>
  </mat-form-field>

  <div class="flex items-center justify-between">
  <label class="text-sm font-medium text-gray-700 mb-2 block">Questions</label>
  <button type="button" mat-button (click)="addQuestion()">
    <mat-icon>add</mat-icon>
    Add</button>
  </div>
  <div formArrayName="questions">
  @for(questionForm of questionsFormArray.controls;track questionForm;let i = $index){
  <div class="flex items-center justify-center gap-1 w-full" [formGroupName]="i">
    <mat-icon (click)="questionsFormArray.removeAt(i)" class="hover:cursor-pointer mb-auto">delete</mat-icon>
    <mat-form-field appearance="outline" class="w-full">
    <input matInput formControlName="question" placeholder="Enter your question">
    </mat-form-field>
  </div>
  }
  </div>

  <!-- Submit Button -->
  <button type="submit" (click)="addJob()" mat-stroked-button color="primary" [disabled]="!jobForm.valid || loaders.addJob" class="px-6 py-2 ml-auto">
    @if (loaders.addJob) {
    <mat-spinner diameter="20"></mat-spinner>
    } @else {
    Create Job
    }
  </button>
</form>
} @else {
<form [formGroup]="candidateForm" (ngSubmit)="addCandidate()" class="flex flex-col gap-4">

  <!-- Header -->
  <div class="bg-[#212529] p-4 mb-4 w-full">
    <h1 class="text-lg md:text-3xl font-semibold text-white">Add Candidate</h1>
    <p class="text-indigo-100 mt-1">Add candidate name and resume</p>
  </div>

  <mat-form-field appearance="outline" class="w-full">
    <mat-icon matPrefix class="text-gray-400">person</mat-icon>
    <p mat-label>Name</p>
    <input matInput formControlName="name" placeholder="Enter candidate name" pattern="[a-zA-Z ]+">
    <mat-error>Please enter a valid name</mat-error>
  </mat-form-field>

  <label class="text-sm font-medium text-gray-700 mb-2 block">Resume Upload</label>
  <div class="flex items-center justify-center w-full">
    <label
      class="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-all duration-200">
      <div class="flex flex-col items-center justify-center pt-5 pb-6">
        <mat-icon class="text-gray-400 mb-2">cloud_upload</mat-icon>
        <p class="mb-2 text-sm text-gray-500">
          <span class="font-semibold">Click to upload</span> or drag and drop
        </p>
        <p class="text-xs text-gray-500">PDF, DOC, DOCX up to 10MB</p>
      </div>
      <input type="file" class="hidden" accept=".pdf,.doc,.docx" (change)="onFileChange($event)">
    </label>
  </div>
  @if (candidateForm.value.file || '') {
  <div class="mt-2 text-sm text-gray-600 flex items-center gap-2">
    <mat-icon class="text-green-500 text-base">check_circle</mat-icon>
    <span>{{ candidateForm.value.file.name || '' }}</span>
  </div>
  }

  <button [disabled]="candidateForm.invalid" mat-stroked-button class="ml-auto">
    @if (loaders.addCandidate) {
    <mat-spinner diameter="20"></mat-spinner>
    } @else {
    Add Candidate
    }
  </button>
</form>
}
